import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mensagem-retorno',
  templateUrl: './mensagem-retorno.component.html',
  styleUrls: ['./mensagem-retorno.component.scss']
})
export class MensagemRetornoComponent implements OnInit {
  
  public tipoMensagem:string = "success";
  public mensagens:any = [];

  constructor() { }

  ngOnInit(): void {
  }

}
